import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, AlertCircle } from "lucide-react";
import { api } from "../lib/api";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState({ state: "checking", message: "Confirming your payment…" });

  useEffect(() => {
    if (!sessionId) {
      setStatus({ state: "error", message: "Missing session id." });
      return;
    }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus({ state: "success", message: "Payment received. Thank you." });
          return;
        }
        if (data.status === "expired") {
          setStatus({ state: "error", message: "This checkout session expired. Please try again." });
          return;
        }
        attempts++;
        if (attempts >= 8) {
          setStatus({ state: "pending", message: "Payment is processing. You'll receive an email once confirmed." });
          return;
        }
        setTimeout(poll, 2000);
      } catch (e) {
        setStatus({ state: "error", message: "Could not verify payment. Please contact us." });
      }
    };
    poll();
  }, [sessionId]);

  const isSuccess = status.state === "success";
  return (
    <div className="py-24 px-6 max-w-2xl mx-auto text-center" data-testid="checkout-success-page">
      {isSuccess ? (
        <CheckCircle2 size={64} className="mx-auto text-[#D4AF37]" />
      ) : (
        <AlertCircle size={64} className="mx-auto text-[#8B0000]" />
      )}
      <h1 className="font-serif text-4xl mt-6">{isSuccess ? "Thank You" : "Payment Status"}</h1>
      <p className="mt-4 text-white/70 text-lg" data-testid="checkout-status-msg">{status.message}</p>
      <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
        <Link to="/" className="bg-[#8B0000] hover:bg-[#A50000] text-white px-8 py-3 text-xs uppercase tracking-[0.2em]">Back to Home</Link>
        <Link to="/shop" className="border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black px-8 py-3 text-xs uppercase tracking-[0.2em]">Continue Shopping</Link>
      </div>
    </div>
  );
}
